import { List } from "@mui/material"
import { useCallback } from "react"
import { useLocalStorage } from "react-use"
import PlayerEventsListItem from "./PlayerEventsListItem"

const IGNORED_FIELDS = new Set([
    "eventType"
])

const PlayerEventsList = ({ playerEvent, storageKey }) => {
    const [settings, setSettings] = useLocalStorage(storageKey, null)

    const handleChange = useCallback((eventType, eventKey) => {
        if (settings === null) {
            setSettings({ [eventType]: [eventKey] })
        } else if (!Object.hasOwn(settings, eventType)) {
            setSettings({ ...settings, [eventType]: [eventKey] })
        } else {
            const eventTypeSettings = settings[eventType]
            if (eventTypeSettings.includes(eventKey)) {
                eventTypeSettings.splice(eventTypeSettings.indexOf(eventKey), 1)
                setSettings({ ...settings, [eventType]: eventTypeSettings })
            } else {
                setSettings({ ...settings, [eventType]: [...eventTypeSettings, eventKey] })
            }
        }
    }, [settings, setSettings])

    return (
        <List dense>
            {Object.entries(playerEvent).filter(([eventKey, _]) => !IGNORED_FIELDS.has(eventKey)).map(([eventKey, eventValue]) => (
                <PlayerEventsListItem
                    key={eventKey}
                    eventType={playerEvent.eventType}
                    eventKey={eventKey}
                    eventValue={eventValue}
                    checked={settings?.[playerEvent.eventType]?.includes(eventKey)}
                    onChange={handleChange}
                />
            ))}
        </List>
    )
}

export default PlayerEventsList
